import React from 'react';
import ReactDOM from 'react-dom';
import './dayjsGlobal.js';
import { App } from './react/app/components/app/App';

function bootstrapApp() {
  ReactDOM.render(
    React.createElement(App),
    document.getElementById('root')!
  );
}

bootstrapApp();
